import {Divider, Text} from '@chakra-ui/react';
import {IconBlock} from 'components/layouts/aside-layout';
import {colors} from 'components/providers';
import {Counter} from 'components/shared';
import {FC} from 'react';

interface IProps {
  value: number;
  onChange: (value: number) => void;
  title: string;
  description: string;
}

export const Cutlery: FC<IProps> = ({value, onChange, title, description}) => {
  return (
    <IconBlock heading={title} icon="/icons/cutlery.svg">
      <Text color={colors.textGray} fontWeight="500" fontSize="12px">
        {description}
      </Text>
      <Divider my="15px" />
      <Counter defaultValue={value} onChange={onChange} min={0} />
    </IconBlock>
  );
};
